import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20home%20cinema%20room%20with%20a%20large%20projector%20screen%20showing%20colorful%20abstract%20cinematic%20visuals%2C%20comfortable%20sofa%2C%20soft%20warm%20ambient%20lighting%2C%20minimalist%20interior%20design%2C%20golden%20and%20amber%20warm%20tones%2C%20cinematic%20atmosphere%2C%20inviting%20and%20elegant%20aesthetic%2C%20high%20quality%20photography&width=1800&height=800&seq=hero-bg-2025&orientation=landscape"
          alt="温馨家庭影院场景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
          <i className="ri-sparkling-2-line text-secondary-300 text-sm"></i>
          <span className="text-sm text-background-50 font-medium">2025年最新精选</span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          高清免费看片网站
          <br />
          <span className="text-secondary-300">精选推荐合集</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          精选最受欢迎的在线看片网站，涵盖高清电影、热播剧集、综艺纪录片等海量资源。
          帮你快速找到清晰流畅、无广告干扰的观影平台，告别卡顿与低画质烦恼。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/movie"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            开始探索 <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href="#articles"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-lg border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            精选文章 <i className="ri-article-line ml-2"></i>
          </a>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { icon: 'ri-shield-check-line', label: '安全审核' },
            { icon: 'ri-star-line', label: '真实评测' },
            { icon: 'ri-refresh-line', label: '持续更新' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 backdrop-blur-sm">
                <i className={`${item.icon} text-background-50 text-lg`}></i>
              </div>
              <span className="text-xs text-background-200 font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}